// @flow
import React from 'react';
import classNames from 'classnames';
import { Container, Row, Col } from 'reactstrap';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// Components
import LoaderHOC from 'components/atoms/LoaderHOC';
import DealerInfo from 'components/atoms/DealerInfo';

// Types
import type { CTA } from 'api/xws/optimizely/optimizely';

import './AppointmentInfo.scss';
import xtimeLogo from './xtimelogo.png';

const ns = 'appointment-info';

type State = {
  imgSrc: string
};

type Props = {
  className: string,
  dealerLogoURL?: string,
  logoUrl?: string,
  showHeader: boolean,
  dealerName: string,
  intl: IntlShape,
  ctaBanner: CTA | null
};

export default class AppointmentInfo extends React.Component<Props, State> {
  static getDerivedStateFromProps(nextProps: Props) {
    if (nextProps.dealerLogoURL || nextProps.logoUrl) {
      return { imgSrc: nextProps.dealerLogoURL || nextProps.logoUrl };
    }
    return { imgSrc: xtimeLogo };
  }

  constructor(props: Props) {
    super(props);
    (this: any).state = {
      imgSrc: xtimeLogo
    };
  }

  render() {
    const { className, showHeader, dealerName, intl, ctaBanner } = this.props;
    const { imgSrc } = this.state;
    const classProps = classNames({
      [ns]: true,
      [className]: Boolean(className),
      [`${ns}--cta`]: ctaBanner
    });
    return showHeader ? (
      <Container className={classProps}>
        <Row>
          <Col xs={4} className={`${ns}__logo d-flex align-items-center`}>
            <LoaderHOC
              serviceId={'statusTracker|data|settings'}
              placeHolderType={() => <div />}
              component={() => (
                <img
                  className={`${ns}__logo--img`}
                  src={imgSrc}
                  alt={intl.formatMessage(
                    {
                      id: 'c8.aria.dealer.home.page',
                      defaultMessage: '{dealerName} home page'
                    },
                    {
                      dealerName
                    }
                  )}
                />
              )}
            />
          </Col>
          <Col xs={8} className={`${ns}__title`}>
            <DealerInfo />
          </Col>
        </Row>
      </Container>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/AppointmentInfo/AppointmentInfo.js